import * as React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18n-react';
import CompaniesIdentity from '../CompaniesIdentity/CompaniesIdentity';
import Calendar from '../../../../components/searchBox/calendar/Calendar';
import FlightAutocomplete from '../../../../components/searchBox/flightAutocomplete/FlightAutocomplete';
import ClearAllFilters from '../ClearAllFilters/ClearAllFilters';
import Moment from 'moment';
import { Col, Row } from 'antd';
import './FilterFlight.css'

const propTypes = {
	flightOriginRef: PropTypes.string,
	flightDestinyRef: PropTypes.string,
	startDateRef: PropTypes.string,
	childKey: PropTypes.number,
  };

class FilterFlight extends React.Component {
	flightOriginRef;
	flightDestinyRef;
	startDateRef;
	childKey;
	constructor(props) {
		super(props);

		this.state = {
			minSelectionDate: Moment()
				.startOf('day')
				.add(0, 'day')
				.toISOString(),
			handleAirportSearch: props.handleAirportSearch,
			filteredList: {
				listCompany: null,
				flightOrigin: null,
				flightDestiny: null,
				data: null
			},
			endDate: null,
			listCompany: null,
			flightOrigin: null,
			flightDestiny: null
		};
		this.setCompaniesIdentity = this.setCompaniesIdentity.bind(this);
		this.setFlightOrigin = this.setFlightOrigin.bind(this);
		this.setFlightDestiny = this.setFlightDestiny.bind(this);
		this.clearFilters = this.clearFilters.bind(this);
		this.handlerStartDate = this.handlerStartDate.bind(this);
		this.childKey = 0;
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevState.filteredList !== this.state.filteredList)
			this.props.callbackFilteredList(this.state.filteredList)
	}

	setCompaniesIdentity(value) {
		this.setState({
			filteredList: {
				...this.state.filteredList,
				listCompany: value
			}
		});
	}

	setFlightOrigin(value) {
		this.setState({
			flightOrigin: value,
			filteredList: {
				...this.state.filteredList,
				flightOrigin: value
			}
		});
	}

	setFlightDestiny(value) {
		this.setState({
			flightDestiny: value,
			filteredList: {
				...this.state.filteredList,
				flightDestiny: value
			}
		});
	}

	handlerStartDate(value) {
		this.setState({
			endDate: value,
			filteredList: {
				...this.state.filteredList,
				data: value
			}
		});
	}

	clearFilters() {
		this.setState({
			endDate: null,
			flightOrigin: null,
			flightDestiny: null,
			filteredList: {
				listCompany: null,
				flightOrigin: null,
				flightDestiny: null,
				data: null
			}
		});

	}

	renderAutocomplete() {
		return (
			<div className="row-flight" key={this.childKey}>
				<FlightAutocomplete
					value={this.state.flightOrigin}
					id="autocompleteSearchFlightOrigin"
					placeholder={i18n.translate('placeholder.flightOrigin')}
					title={i18n.translate('label.titleFlightOrigin')}
					searchAirport={(searchTerm) => {
						return this.props.handleAirportSearch(searchTerm, this.state.flightDestiny);
					}}
					callBack={this.setFlightOrigin}
					ref={(e) => (this.flightOriginRef = e)}
				/>
				<div className="azul-icon-airplane" key={this.childKey} />
				<FlightAutocomplete
					value={this.state.flightDestiny}
					id="autocompleteSearchFlightDestination"
					placeholder={i18n.translate('placeholder.flightDestination')}
					title={i18n.translate('label.titleFlightDestination')}
					searchAirport={(searchTerm) =>
						this.props.handleAirportSearch(searchTerm, this.state.flightOrigin)
					}
					callBack={this.setFlightDestiny}
					ref={(e) => (this.flightDestinyRef = e)}
				/>
			</div>
		);
	}

	renderCalendar() {
		return (
			<div className="div-calendar">
					<Calendar
						id="calendarStartDate"
						placeholder={i18n.translate('placeholder.selectDate')}
						title={i18n.translate('home.label.titleStartDate')}
						onChange={this.handlerStartDate}
						value={this.state.endDate}
						minDate={this.state.minSelectionDate}
						ref={e => (this.startDateRef = e)}
						key={this.childKey}
					/>
			</div>
		);
	}

	renderCompanies() {
		return (
			<div>
				<CompaniesIdentity
					callbackCompaniesIdentity={this.setCompaniesIdentity}
					ref="CompaniesIdentity"
					searchResult={this.props.searchResult}
					key={this.childKey}
				/>
			</div>
		)
	}

	renderClearFilter() {
		return (
			<div>
				<ClearAllFilters
					clearFilters={() => {
						this.clearFilters();
						++this.childKey;
					}}
				/>
			</div>
		)
	}


	render() {
		return (
			<div className="bg-white">
				<Row>
					<Col xs={12}>
						<div data-unit="title" className="titleFilter">
							{i18n.translate('label.filter').toString()}
						</div>
					</Col>
				</Row>
				<Row className='filter'>
					{this.renderAutocomplete()}
					{this.renderCalendar()}
					{this.renderCompanies()}
					{this.renderClearFilter()}
				</Row>
			</div>
		);
	}
}

FilterFlight.propTypes = propTypes;

export default FilterFlight;


// WEBPACK FOOTER //
// ./src/page/searchResultPage/components/FilterFlight/FilterFlight.jsx